import { render, staticRenderFns } from "./MaterialsDashboard.vue?vue&type=template&id=a4631644"
import script from "./MaterialsDashboard.vue?vue&type=script&lang=js"
export * from "./MaterialsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports